// plugins/aws-s3.js
import AWS from "aws-sdk";
import { serverHttp as Request } from "../services/http";
import config from "@/settings/aws"; // 可选：如果需要解码配置
import { decode } from "js-base64";

export default defineNuxtPlugin((nuxtApp) => {
  let s3Instance = null;
  let expirationTime = null;
  let refreshTimer = null;
  const REFRESH_THRESHOLD = 300; // 5分钟

  // 初始化 S3 实例
  async function initS3() {
    if (!s3Instance) {
      const { credentials, newInstance } = await refreshCredentials();
      s3Instance = newInstance;
      expirationTime = new Date(credentials.expiration).getTime();
      startRefreshTimer();
    }
    return s3Instance;
  }

  // 刷新临时 STS 凭证
  async function refreshCredentials() {
    try {
      const response = await Request.get("sharkfoto/get_sts_access_key");
      if (!response.data?.credentials) throw new Error("无效的凭证响应");

      const credentials = response.data.credentials;
      const newInstance = new AWS.S3({
        apiVersion: config.aa ? decode(decode(config.aa)) : "2006-03-01",
        accessKeyId: credentials.accessKeyId,
        secretAccessKey: credentials.secretAccessKey,
        sessionToken: credentials.sessionToken,
        region: config.dd ? decode(decode(config.dd)) : "us-east-1",
      });

      console.log("[S3] 凭证刷新成功", credentials.expiration);
      return { credentials, newInstance };
    } catch (err) {
      console.error("[S3] 凭证刷新失败:", err);
      throw err;
    }
  }

  // 定时检查凭证是否即将过期
  function startRefreshTimer() {
    if (refreshTimer) clearInterval(refreshTimer);

    refreshTimer = setInterval(async () => {
      if (!expirationTime) return;
      const now = Date.now();
      const secondsUntilExpiration = (expirationTime - now) / 1000;

      if (secondsUntilExpiration < REFRESH_THRESHOLD) {
        console.log("[S3] 凭证即将过期，自动刷新中...");
        try {
          const { credentials, newInstance } = await refreshCredentials();
          s3Instance = newInstance;
          expirationTime = new Date(credentials.expiration).getTime();
          console.log("[S3] 凭证刷新完成");
        } catch (err) {
          console.error("[S3] 自动刷新失败，将在下一次尝试刷新");
        }
      }
    }, 60000); // 每分钟检查一次
  }

  // 卸载时清理定时器
  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", () => {
      if (refreshTimer) clearInterval(refreshTimer);
    });
  }

  // Proxy 延迟初始化 S3，保证调用时已获取凭证
  const s3Proxy = new Proxy(
    {},
    {
      get(target, prop) {
        return async (...args) => {
          const instance = await initS3();
          if (typeof instance[prop] === "function") {
            return instance[prop](...args);
          }
          return instance[prop];
        };
      },
    }
  );

  // Nuxt 4 provide / inject
  nuxtApp.provide("S3", s3Proxy);
  nuxtApp.provide("$S3", s3Proxy);

  // 组件中 this.$S3
  const globals = nuxtApp.vueApp.config.globalProperties;
  if (!Object.getOwnPropertyDescriptor(globals, "$S3")) {
    Object.defineProperty(globals, "$S3", {
      get() {
        return s3Proxy;
      },
      configurable: true,
      enumerable: true,
    });
  }

  // 立即初始化 S3
  initS3();
});
